export default "__VITE_ASSET__CHJOON_D__"